import { FC, memo, useEffect, useRef, useState } from "react";
import appStyles from "../../App.module.css";

interface PopoverIconProps {
  text: string;
  size?: "xs" | "sm";
  children?: JSX.Element;
}

const PopoverIcon: FC<PopoverIconProps> = (props: PopoverIconProps) => {
  const [showPopover, setShowPopover] = useState<boolean>(false);
  const sizeClasses = {
    xs: appStyles.popoverXs,
    sm: appStyles.popoverSm,
  };
  const sizeClass: string = props.size
    ? sizeClasses[props.size]
    : sizeClasses.xs;

  const popoverRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    document.addEventListener("click", (event: any) => {
      if (popoverRef.current && !popoverRef.current.contains(event.target)) {
        setShowPopover(false);
      }
    });
  }, [showPopover]);

  return (
    <div
      ref={popoverRef}
      className={`${appStyles.btPopover} ${showPopover ? appStyles.show : ""}`}>
      <span
        onClick={() => {
          setShowPopover(!showPopover);
        }}
        className={`${appStyles.labelInfoIcon} ${appStyles.btLabelInfoIcon} `}></span>

      <span
        className={`${appStyles.btPopoverText} ${sizeClass}`}
        dangerouslySetInnerHTML={{ __html: props.text }}></span>
    </div>
  );
};

export default memo(PopoverIcon);
